var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.37504 2.3335H23.625C24.752 2.3335 25.6667 3.24816 25.6667 4.37516V23.6252C25.6667 24.1665 25.452 24.6857 25.0682 25.0683C24.6855 25.4513 24.1664 25.6666 23.625 25.6668H4.37504C3.83371 25.6668 3.31454 25.4522 2.93187 25.0683C2.54893 24.6857 2.33364 24.1665 2.33337 23.6252V4.37516C2.33337 3.24816 3.24804 2.3335 4.37504 2.3335ZM4.08337 4.37516V23.6252C4.08337 23.7862 4.21404 23.9168 4.37504 23.9168H12.8334V4.0835H4.37504C4.29769 4.0835 4.2235 4.11423 4.1688 4.16892C4.1141 4.22362 4.08337 4.29781 4.08337 4.37516ZM14.5834 23.9168H23.625C23.7024 23.9168 23.7766 23.8861 23.8313 23.8314C23.886 23.7767 23.9167 23.7025 23.9167 23.6252V4.37516C23.9167 4.29781 23.886 4.22362 23.8313 4.16892C23.7766 4.11423 23.7024 4.0835 23.625 4.0835H14.5834V23.9168Z",
    fill: "#1F3048"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewIcon);
export default __webpack_public_path__ + "static/media/overviewIcon.c6e29e4a88930f493214b9332c2d26c5.svg";
export { ForwardRef as ReactComponent };